module.exports = __webpack_public_path__ + "img/au-nt.ceb573dc.svg";